<div mat-dialog-content class="mat-dialog-content">
  <h2 class="title">
    Recuperar contraseña
  </h2>
  <mat-form-field class="full-width-input" appearance="outline">
    <mat-label class="text-field"><b>CORREO ELECTRONICO</b></mat-label>
    <input matInput [(ngModel)]="email" required />
    <mat-error>
      Por favor ingrese su dirección de correo electronico
    </mat-error>
  </mat-form-field>
  <button class="btn-login" (click)="resetPassword()" mat-raised-button>
    Recuperar
  </button>
</div>